import React from 'react';

import CloseIcon from '@mui/icons-material/Close';
import type { AlertColor } from '@mui/material';
import {
  Alert,
  Button,
  IconButton,
  Snackbar as MuiSnackbar,
} from '@mui/material';
import { makeStyles } from '@mui/styles';

interface DiveProps {
  open: boolean;
  handleClose?: () => void;
  message: string;
  severity: AlertColor;
  action?: {
    buttonName: string;
    func: () => void;
  };
  closable?: boolean;
}

const useStyles = makeStyles(() => ({
  cornNuts: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiAlert-root': {
      fontFamily: 'proxima-nova, sans-serif',
      fontSize: '1em',
    },
    '& .MuiAlert-icon': {
      alignItems: 'center',
      justifyContent: 'center',
    },
    '& .MuiSvgIcon-root': {
      fontSize: '1.2em',
    },
    '& .MuiAlert-message': {
      display: 'flex',
      flexWrap: 'nowrap',
      alignItems: 'center',
      gap: '.5em',
    },
    '&.MuiSnackbar-root': {
      borderRadius: '.4em',
      boxShadow: '0 .2em .5em rgba(0,0,0,0.3)',
      zIndex: 10000,
    },
  },
  snackButton: {
    '&.MuiButtonBase-root': {
      padding: '.3em .6em',
      marginLeft: '.4em',
    },
  },
}));

export const DiveBar: React.FC<DiveProps> = ({
  open,
  handleClose,
  message,
  action,
  severity = 'warning',
  closable = true,
}) => {
  const { buttonName, func } = action ?? {};
  const styles = useStyles();

  return (
    <MuiSnackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      open={open}
      className={styles.cornNuts}
    >
      <Alert severity={severity}>
        {message}
        {action ? (
          <>
            <Button
              variant="outlined"
              color="primary"
              size="small"
              onClick={func}
              className={styles.snackButton}
            >
              {buttonName}
            </Button>
          </>
        ) : null}
        {/** @ts-expect-error TS(2769): No overload matches this call. */}
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={closable && handleClose}
        >
          {closable && <CloseIcon fontSize="small" />}
        </IconButton>
      </Alert>
    </MuiSnackbar>
  );
};
